import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { getAllSpaces } from 'spaces/store/selectors';
import { fetchAllSpacesForAllFolderTrees } from 'spaces/store/actions';
import SpinnerOverlay from 'base/components/SpinnerOverlay/SpinnerOverlay';
import Dashboard from '../Dashboard';
import {
  fetchMyDashboard,
  createMyDashboard,
  updateMyDashboard,
  setMyDashboardCurrentBreakpoint,
} from '../../store/myDashboard/actions';
import {
  getMyDashboard,
  getMyDashboardToolboxWidgets,
  getMyDashboardDataIsLoading,
  getMyDashboardId,
} from '../../store/myDashboard/selectors';
import {
  getAllWidgets,
} from '../../store/dashboards/selectors';
import theme from '../../../theme';


class MainDashboard extends React.Component {
  componentDidMount() {
    this.props.fetchAllSpacesForAllFolderTrees();
    this.props.fetchDashboard();
  }

  onStopEditing = (layouts) => {
    const { dashboard, createDashboard, updateDashboard } = this.props;
    if (!dashboard.id || dashboard.isDefault) {
      createDashboard({ layout: layouts });
    } else {
      dashboard.layout = layouts;
      updateDashboard(dashboard);
    }
  };

  onBreakpointChange = (breakpoint) => {
    this.props.setMyDashboardCurrentBreakpoint(breakpoint);
  };

  render() {
    const {
      widgets, dashboard, toolboxWidgets, isLoading,
    } = this.props;
    return (
      <div style={{ position: 'relative', height: '100%' }}>
        {isLoading && <SpinnerOverlay background={theme.colors.light} />}
        {!isLoading && dashboard && (
          <Dashboard
            onBreakpointChange={this.onBreakpointChange}
            widgets={widgets}
            layouts={dashboard.layout}
            toolboxWidgets={toolboxWidgets}
            onStopEditing={this.onStopEditing}
            dashboardId={dashboard && dashboard.id ? dashboard.id : null}
          />
        )}
      </div>
    );
  }
}
MainDashboard.propTypes = {
  dashboard: PropTypes.objectOf(PropTypes.any).isRequired, // eslint-disable-line
  widgets: PropTypes.arrayOf(PropTypes.any).isRequired,
  toolboxWidgets: PropTypes.objectOf(PropTypes.any).isRequired, // eslint-disable-line
  spaces: PropTypes.arrayOf(PropTypes.object).isRequired, // eslint-disable-line
  isLoading: PropTypes.bool.isRequired, // eslint-disable-line
  fetchDashboard: PropTypes.func.isRequired, // eslint-disable-line
  createDashboard: PropTypes.func.isRequired, // eslint-disable-line
  updateDashboard: PropTypes.func.isRequired, // eslint-disable-line
  fetchAllSpacesForAllFolderTrees: PropTypes.func.isRequired,
  setMyDashboardCurrentBreakpoint: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  spaces: getAllSpaces(state),
  dashboard: getMyDashboard(state),
  dashboardId: getMyDashboardId(state),
  widgets: getAllWidgets(state),
  toolboxWidgets: getMyDashboardToolboxWidgets(state),
  isLoading: getMyDashboardDataIsLoading(state),
});

const mapDispatchToProps = {
  fetchDashboard: fetchMyDashboard,
  createDashboard: createMyDashboard,
  updateDashboard: updateMyDashboard,
  fetchAllSpacesForAllFolderTrees,
  setMyDashboardCurrentBreakpoint,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MainDashboard);
